module.exports = __webpack_public_path__ + "static/media/19-8.2f386a46.mp3";